import React from 'react';
import { Box, Flex, VStack, Heading, Text, Button, Avatar, IconButton, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex minH="100vh" bgGradient="linear(to-br, gray.900, blue.900)" color="white">
      {/* Sidebar Desktop */}
      <Box display={{ base: 'none', md: 'block' }} w="280px" bg="gray.800" p={6} boxShadow="2xl">
        <VStack align="stretch" spacing={8} h="100%">
          <Box>
            <Avatar size="lg" name="Admin" bg="teal.500" mb={3} />
            <Heading size="md">Admin</Heading>
            <Text fontSize="sm" color="gray.300">Painel de Controle</Text>
          </Box>
          <VStack align="stretch" spacing={2}>
            <Button as={RouterLink} to="/admin/dashboard" variant={location.pathname === '/admin/dashboard' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Início</Button>
            <Button as={RouterLink} to="/admin/mensalistas" variant={location.pathname === '/admin/mensalistas' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Mensalistas</Button>
            <Button as={RouterLink} to="/admin/pacotes" variant={location.pathname === '/admin/pacotes' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Pacotes de Mensalistas</Button>
            <Button as={RouterLink} to="/admin/barbeiros" variant={location.pathname === '/admin/barbeiros' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Barbeiros</Button>
            <Button as={RouterLink} to="/admin/servicos" variant={location.pathname === '/admin/servicos' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Serviços</Button>
            <Button as={RouterLink} to="/admin/produtos" variant={location.pathname === '/admin/produtos' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Produtos</Button>
            <Button as={RouterLink} to="/admin/cortes" variant={location.pathname === '/admin/cortes' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Cortes</Button>
            <Button as={RouterLink} to="/admin/sorteio-config" variant={location.pathname === '/admin/sorteio-config' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%">Prêmios do Sorteio</Button>
            <Button variant="ghost" colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={handleLogout}>Sair</Button>
          </VStack>
        </VStack>
      </Box>
      {/* Sidebar Mobile (Drawer) */}
      {isMobile && (
        <>
          {/* Header mobile fixo */}
          <Box
            as="header"
            position="fixed"
            top={0}
            left={0}
            w="100%"
            bg="gray.900"
            zIndex={99}
            px={3}
            py={3}
            boxShadow="md"
            display={{ base: 'flex', md: 'none' }}
            alignItems="center"
            justifyContent="space-between"
          >
            <IconButton
              aria-label="Abrir menu"
              icon={<HamburgerIcon />}
              size="lg"
              colorScheme="yellow"
              onClick={onOpen}
              bg="yellow.400"
              color="black"
            />
            <Heading size="md" color="white" fontWeight="bold" m={0} p={0} fontSize="xl">
              {location.pathname.includes('mensalistas') ? 'Mensalistas' : 'Dashboard'}
            </Heading>
            <Box w="48px" /> {/* Espaço para centralizar o título */}
          </Box>
          <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
            <DrawerOverlay />
            <DrawerContent bg="gray.800" color="white" maxW="280px" w="280px">
              <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
              <DrawerBody>
                <VStack align="stretch" spacing={4} mt={4}>
                  <Button as={RouterLink} to="/admin/dashboard" variant={location.pathname === '/admin/dashboard' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Início</Button>
                  <Button as={RouterLink} to="/admin/mensalistas" variant={location.pathname === '/admin/mensalistas' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Mensalistas</Button>
                  <Button as={RouterLink} to="/admin/pacotes" variant={location.pathname === '/admin/pacotes' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Pacotes de Mensalistas</Button>
                  <Button as={RouterLink} to="/admin/barbeiros" variant={location.pathname === '/admin/barbeiros' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Barbeiros</Button>
                  <Button as={RouterLink} to="/admin/servicos" variant={location.pathname === '/admin/servicos' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Serviços</Button>
                  <Button as={RouterLink} to="/admin/produtos" variant={location.pathname === '/admin/produtos' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Produtos</Button>
                  <Button as={RouterLink} to="/admin/cortes" variant={location.pathname === '/admin/cortes' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Cortes</Button>
                  <Button as={RouterLink} to="/admin/sorteio-config" variant={location.pathname === '/admin/sorteio-config' ? 'solid' : 'ghost'} colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={onClose}>Prêmios do Sorteio</Button>
                  <Button variant="ghost" colorScheme="yellow" justifyContent="flex-start" w="100%" onClick={handleLogout}>Sair</Button>
                </VStack>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </>
      )}
      {/* Main Content */}
      <Box flex={1} p={{ base: 3, md: 10 }} pt={{ base: '70px', md: 10 }}>
        {children}
      </Box>
    </Flex>
  );
};

export default AdminLayout;
